import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-event-management',
  imports: [RouterModule, FeatureHero],
  templateUrl: './event-management.html',
  styleUrl: './event-management.scss',
})
export class EventManagement {

}
